export class LayerGroup {
    onAdd = () => {
        const containerBtn = document.createElement('div');
        containerBtn.style.float = 'right';
        containerBtn.style.marginBottom = '30px';
        containerBtn.style.marginTop = '10px';

        return containerBtn;
    }
}